import { Injectable } from '@angular/core';
import { of, Observable, delay } from 'rxjs';
import { ResidentialComplex, Banner } from '../models/home.model';
import { MOCK_COMPLEXES, MOCK_BANNERS } from '../models/mock-data';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  getLatestComplexes(limit: number): Observable<ResidentialComplex[]> {
    return of(MOCK_COMPLEXES.slice(0, limit)).pipe(delay(300));
  }

  getHomeBanners(): Observable<Banner[]> {
    return of(MOCK_BANNERS).pipe(delay(200));
  }
}
